module.exports = __webpack_public_path__ + "static/media/profile-pic.ebd199a6.png";